import { render, staticRenderFns } from "./BaseCell.vue?vue&type=template&id=fb362c5c"
import script from "./BaseCell.vue?vue&type=script&lang=js"
export * from "./BaseCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports